enum NotificationDismissibleEnum {
    BOTH = "both",
    CLICK = "click",
    NONE = "none",
}

export default NotificationDismissibleEnum;
